module.exports = __webpack_public_path__ + "img/btn6.2563c644.png";